import { datadogRum } from '@datadog/browser-rum'

interface DatadogRumConfig {
  applicationId: string
  clientToken: string
  sessionReplaySampleRate: number
  site: string
  env: string
  service: string
  version: string
}

export function initDatadogRum(config: DatadogRumConfig): boolean {
  const hasRequiredCredentials = Boolean(config.applicationId && config.clientToken && config.service)

  if (!hasRequiredCredentials) {
    return false
  }

  datadogRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    defaultPrivacyLevel: 'mask-user-input',
    env: config.env,
    service: config.service,
    sessionReplaySampleRate: Number(config.sessionReplaySampleRate),
    sessionSampleRate: 100,
    site: config.site,
    trackLongTasks: true,
    trackResources: true,
    trackUserInteractions: true,
    version: config.version,
  })

  return true
}
